/**
 * Small, reusable helpers for config hooks.
 * Import these in your config files or migrator as needed.
 */

/**
 * keyPruning(obj, modelTemplate)
 * Remove keys from `obj` that do not exist in `modelTemplate` (shallow).
 * Returns the same object reference after pruning.
 */
export function keyPruning(obj, modelTemplate) {
  console.log("keyPruning");
  if (!obj || !modelTemplate || Array.isArray(modelTemplate)) return obj;
  if (typeof modelTemplate !== "object") return obj;
  for (const k of Object.keys(obj)) {
    if (!(k in modelTemplate)) delete obj[k];
  }
  return obj;
}

/**
 * applyTransform(obj, transformFn, ctx)
 * Run a user-supplied transform hook safely. Can mutate and/or return a new object.
 * Returns the transformed object (or the original if no transform is provided).
 */
export function applyTransform(obj, transformFn, ctx) {
  if (typeof transformFn !== "function") return obj;
  const out = transformFn(obj, ctx);
  return out || obj;
}

// Matches exactly "YYYY-MM-DD" (no extra characters before/after)
const DATE_ONLY_REGEX = /^\d{4}-\d{2}-\d{2}$/;

/**
 * Recursively walks any value (object/array/primitive) and:
 * - if it finds a string that matches YYYY-MM-DD exactly
 * - and new Date(...) is valid
 *   -> replaces it with a Unix timestamp in milliseconds.
 *
 * Mutates the passed-in value in place and also returns it.
 */
export function convertDateStringsToTimestamps(value) {
  // Arrays: walk each element (if data array is passed in)
  if (Array.isArray(value)) {
    for (let i = 0; i < value.length; i++) {
      value[i] = convertDateStringsToTimestamps(value[i]);
    }
    return value;
  }

  // Plain objects: walk each key
  if (value && typeof value === "object") {
    for (const key of Object.keys(value)) {
      const v = value[key];

      if (typeof v === "string" && DATE_ONLY_REGEX.test(v)) {
        const timestamp = new Date(v).getTime(); // ms since epoch

        // Skip if invalid (NaN) – per your criteria
        if (!Number.isNaN(timestamp)) {
          value[key] = parseInt(timestamp);
        }
      } else if (v && typeof v === "object") {
        // Recurse into nested objects / arrays (2–3 levels or more is fine)
        convertDateStringsToTimestamps(v);
      }
    }
    return value;
  }

  // Primitives (number, non-matching string, boolean, null, etc.)
  return value;
}
